var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColtDreaptaJosPunctat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 102,
    viewBox: "0 0 111 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 51.5L55 51.5L54.4227 0.25",
    stroke: "black",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColtDreaptaJosPunctat);
export default __webpack_public_path__ + "static/media/colt_dreapta_jos_punctat.af0bb018e10ab6e01903cd020aa57bff.svg";
export { ForwardRef as ReactComponent };